<a
    class="pill pill--deal"
    (click)="openDeal()">
    <i class="las la-dollar-sign"></i>
    {{ getTitle() }}
</a>
